/* istanbul ignore file */
import React from 'react';
import { UpdateBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import JournalEntryBreadcrumbs from 'domain/finance/journalEntry/shared/JournalEntryBreadcrumbs';

const UpdateLedgerBreadcrumbs = () => {
  return (
    <JournalEntryBreadcrumbs>
      <UpdateBreadcrumbItem entity="Journal Entry" />
    </JournalEntryBreadcrumbs>
  );
};

export default UpdateLedgerBreadcrumbs;
